module.exports = __webpack_public_path__ + "img/C2_08.42aa8d41.png";